import { TNotesProps } from './Notes.types'
import React, { FC } from 'react'
import { PlusCircleFilled } from '@ant-design/icons'
import { ButtonBase, IconButton, TextField, Typography } from '@mui/material'
import { Close } from '@mui/icons-material'
import { useNotesLogic } from './Notes.logic'
import './Notes.scss'
export const Notes: FC<TNotesProps> = (props) => {
  const { notes, addNote, removeNote, handleNoteChange } = useNotesLogic(props)

  return (
    <div className="special-request-notes-container">
      <div className="title-container">
        <Typography variant="h3">Other Notes</Typography>
        <IconButton onClick={addNote} color="primary" size="large">
          <PlusCircleFilled />
        </IconButton>
      </div>

      <div className="note">
        {notes.map((note, index) => (
          <React.Fragment key={index}>
            <TextField
              multiline
              fullWidth
              value={note}
              variant="outlined"
              id={String(index)}
              label={`Note ${index + 1}`}
              onChange={handleNoteChange}
              InputProps={{
                endAdornment: notes.length > 1 && (
                  <ButtonBase onClick={() => removeNote(index)}>
                    <Close />
                  </ButtonBase>
                ),
              }}
            />
          </React.Fragment>
        ))}
      </div>
    </div>
  )
}
